import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=6505cb68&scoped=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=6505cb68&prod&lang=scss&scoped=true"
import style1 from "./DocumentViewer.vue?vue&type=style&index=1&id=6505cb68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505cb68",
  null
  
)

export default component.exports